import { render, staticRenderFns } from "./SelectableServiceResources.vue?vue&type=template&id=39da2a99&"
import script from "./SelectableServiceResources.vue?vue&type=script&lang=ts&"
export * from "./SelectableServiceResources.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports